import { useState } from 'react';

const T = {
  bg:'#06060d',s1:'#0d0c18',s2:'#12111e',s3:'#181628',
  border:'rgba(255,255,255,0.07)',border2:'rgba(255,255,255,0.13)',
  gold:'#d4a853',gold2:'#f0c878',cream:'#f0ead8',
  text2:'#9890b0',text3:'#55506a',teal:'#1a8a76',
  error:'#ff6b6b',rust:'#e74c3c',purple:'#8b5cf6',
};

const inp = (x={}) => ({background:T.s3,border:`1px solid ${T.border2}`,borderRadius:8,padding:'0.5rem 0.75rem',color:T.cream,fontSize:12,outline:'none',fontFamily:'inherit',width:'100%',boxSizing:'border-box',...x});
const sel = (x={}) => ({...inp(),cursor:'pointer',...x});
const Btn = ({children,onClick,gold,small,disabled,style={}}) => (<button onClick={onClick} disabled={disabled} style={{background:gold?`linear-gradient(135deg,${T.gold},${T.gold2})`:T.s3,border:gold?'none':`1px solid ${T.border2}`,borderRadius:8,padding:small?'4px 10px':'0.65rem 1.25rem',color:gold?T.bg:T.cream,fontSize:small?11:13,fontWeight:gold?700:400,cursor:disabled?'not-allowed':'pointer',opacity:disabled?0.5:1,fontFamily:'inherit',...style}}>{children}</button>);
const Field = ({label:l,children,hint}) => (<div style={{marginBottom:12}}><div style={{fontSize:10,color:T.text3,textTransform:'uppercase',letterSpacing:2,marginBottom:4}}>{l}</div>{children}{hint&&<div style={{fontSize:10,color:T.text3,marginTop:4}}>{hint}</div>}</div>);

const ACCOUNT_TYPES = [
  {
    id:'artisan', label:'Artisan', icon:'✦', color:T.gold,
    desc:'Individual creative professional — actor, musician, photographer, designer, writer, filmmaker, or any creative discipline.',
    subtypes:['Actor','Musician','Photographer','Filmmaker','Designer','Writer','Dancer','Model','Visual Artist','Content Creator','Multi-Discipline','Other'],
    requiresPortfolio:true, requiresEIN:false, isEntity:false,
    permissions:['Post to Reel','Apply to Castings','Vizion','Curtainz','Audition Tracker','Self-Tape Studio','Contracts','Brand Deal Tracker']
  },
  {
    id:'scout', label:'Scout', icon:'🔍', color:T.teal,
    desc:'Talent discovery professional. Browse and flag talent, recommend to agencies. Cannot sign talent directly.',
    subtypes:['Talent Scout','Brand Scout','Music Scout','Sports Scout','Other'],
    requiresPortfolio:false, requiresEIN:false, isEntity:false,
    permissions:['Browse Talent','Flag Talent','Recommend to Agency','Search','View Profiles']
  },
  {
    id:'agent', label:'Agent', icon:'🤝', color:T.cream,
    desc:'Individual talent agent. Manage a roster, submit talent to castings, negotiate on their behalf.',
    subtypes:['Talent Agent','Booking Agent','Literary Agent','Music Agent','Commercial Agent','Other'],
    requiresPortfolio:false, requiresEIN:false, isEntity:false,
    permissions:['Manage Roster','Submit to Castings','Accept Bookings','View Client Messages','Edit Client Profiles','Commission Tracking']
  },
  {
    id:'manager', label:'Manager', icon:'📋', color:T.purple,
    desc:'Individual talent manager. Unlimited roster, full career management, strategic direction.',
    subtypes:['Personal Manager','Business Manager','Tour Manager','Brand Manager','Other'],
    requiresPortfolio:false, requiresEIN:false, isEntity:false,
    permissions:['Unlimited Roster','Submit to Castings','Accept Bookings','View Client Messages','Edit Client Profiles','Commission Tracking','Career Strategy Tools']
  },
  {
    id:'agency', label:'Agency', icon:'🏢', color:T.gold,
    desc:'Talent agency as a business entity. Houses multiple agents, manages collective roster, requires EIN verification.',
    subtypes:['Talent Agency','Modeling Agency','Music Agency','Literary Agency','Sports Agency','Brand Agency','Full Service Agency','Other'],
    requiresPortfolio:false, requiresEIN:true, isEntity:true,
    permissions:['Multiple Agent Accounts','Collective Roster','Submit Talent','Bulk Casting Tools','Agency Profile','Verified Business Badge']
  },
  {
    id:'studio', label:'Studio', icon:'🎛', color:T.teal,
    desc:'Creative studio business entity. Books sessions, posts opportunities, manages a team of creatives.',
    subtypes:['Recording Studio','Photography Studio','Production Studio','Post-Production Studio','Creative Studio','Multi-Discipline Studio','Other'],
    requiresPortfolio:false, requiresEIN:true, isEntity:true,
    permissions:['Studio Profile','Book Sessions','Post Opportunities','Team Accounts','Client Management','Equipment Listings']
  },
  {
    id:'production_company', label:'Production Company', icon:'🎬', color:T.rust,
    desc:'Film, TV, commercial, or content production company. Post jobs, cast talent, manage productions.',
    subtypes:['Film Production','TV Production','Commercial Production','Content Production','Music Video Production','Theatre Company','Other'],
    requiresPortfolio:false, requiresEIN:true, isEntity:true,
    permissions:['Post Castings','Post Jobs','Manage Productions','Vizion Boards','Curtainz Projects','Team Accounts','Verified Business Badge']
  },
  {
    id:'venue', label:'Venue', icon:'🏛', color:T.text2,
    desc:'Performance space, event venue, or cultural institution. List your space, host events, book talent.',
    subtypes:['Performance Venue','Concert Hall','Gallery','Theatre','Club/Bar','Outdoor Space','Cultural Institution','Other'],
    requiresPortfolio:false, requiresEIN:true, isEntity:true,
    permissions:['Venue Profile','GPS Discovery on Aisle','Post Events','Book Talent','Ticketing','Venue Analytics']
  },
  {
    id:'industry_pro', label:'Industry Pro', icon:'⭐', color:T.gold2,
    desc:'Casting director, music supervisor, brand director, or other senior industry professional.',
    subtypes:['Casting Director','Music Supervisor','Brand Director','A&R','Art Director','Creative Director','Executive Producer','Other'],
    requiresPortfolio:false, requiresEIN:false, isEntity:false,
    permissions:['Unlimited Talent Search','Verification Score Visibility','Post Castings','Industry Pro Badge','Priority Support']
  },
];

const ENTITY_ROLES = ['Owner','Agent','Booking Manager','Engineer/Photographer','Admin','Staff'];
const STUDIO_SUBTYPES = ['Recording Studio','Photography Studio','Production Studio','Post-Production Studio','Creative Studio','Multi-Discipline Studio','Other'];

function EINVerification({ businessName, ein, onBusinessNameChange, onEINChange, verificationStatus, onVerify }) {
  return (
    <div style={{background:'rgba(212,168,83,0.06)',border:`1px solid ${T.gold}30`,borderRadius:12,padding:16,marginTop:12}}>
      <div style={{fontSize:12,fontWeight:700,color:T.gold,marginBottom:4}}>Business Verification Required</div>
      <div style={{fontSize:11,color:T.text2,marginBottom:12,lineHeight:1.7}}>Business entity accounts require EIN verification. Your EIN will be checked against IRS records. This protects all users on the platform.</div>
      <Field label="Legal Business Name">
        <input value={businessName} onChange={e=>onBusinessNameChange(e.target.value)} style={inp()} placeholder="Exact name as registered with IRS"/>
      </Field>
      <Field label="Employer Identification Number (EIN)" hint="Format: XX-XXXXXXX">
        <input value={ein} onChange={e=>onEINChange(e.target.value.replace(/[^0-9-]/g,''))} style={inp()} placeholder="XX-XXXXXXX" maxLength={10}/>
      </Field>
      {verificationStatus==='pending' && (
        <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',background:T.s3,borderRadius:8,marginBottom:8,fontSize:11,color:T.gold}}>
          <div style={{width:8,height:8,borderRadius:'50%',background:T.gold,animation:'pulse 1s infinite'}}/>
          Verifying against IRS records...
        </div>
      )}
      {verificationStatus==='verified' && (
        <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',background:'rgba(26,138,118,0.1)',borderRadius:8,marginBottom:8,fontSize:11,color:T.teal}}>
          ✓ Business verified — Verified Business badge will appear on your profile
        </div>
      )}
      {verificationStatus==='failed' && (
        <div style={{padding:'8px 12px',background:'rgba(231,76,60,0.1)',borderRadius:8,marginBottom:8,fontSize:11,color:T.rust}}>
          ✗ Could not verify EIN. Check your information and try again, or continue for manual review (account held pending approval).
        </div>
      )}
      {verificationStatus==='unverified' && businessName && ein.length>=9 && (
        <Btn gold small onClick={onVerify}>Verify EIN →</Btn>
      )}
    </div>
  );
}

function PortfolioGate({ crafts, onCraftsChange, portfolioUploaded, onPortfolioUpload }) {
  const [file, setFile] = useState(null);
  return (
    <div style={{background:'rgba(139,92,246,0.06)',border:`1px solid ${T.purple}30`,borderRadius:12,padding:16,marginTop:12}}>
      <div style={{fontSize:12,fontWeight:700,color:T.purple,marginBottom:4}}>Artisan Identity Verification</div>
      <div style={{fontSize:11,color:T.text2,marginBottom:12,lineHeight:1.7}}>Artizan is a platform for working creatives. Upload at least one work sample and declare your primary craft to activate your account. Your sample can be a photo, video, audio file, or document.</div>
      <Field label="Primary Craft(s) — select all that apply">
        <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:4}}>
          {['Acting','Music','Photography','Filmmaking','Design','Writing','Dance','Modeling','Visual Art','Content Creation','Fashion','Theatre','Other'].map(craft=>(
            <button key={craft} onClick={()=>{const c=crafts.includes(craft)?crafts.filter(x=>x!==craft):[...crafts,craft];onCraftsChange(c);}} style={{background:crafts.includes(craft)?T.gold:T.s3,color:crafts.includes(craft)?T.bg:T.text2,border:`1px solid ${crafts.includes(craft)?T.gold:T.border2}`,borderRadius:20,padding:'4px 12px',fontSize:11,cursor:'pointer',fontFamily:'inherit',fontWeight:crafts.includes(craft)?700:400}}>
              {craft}
            </button>
          ))}
        </div>
      </Field>
      <Field label="Work Sample (photo, video, audio, or document)">
        <div onClick={()=>document.getElementById('portfolio-upload').click()} style={{border:`2px dashed ${portfolioUploaded?T.teal:T.border2}`,borderRadius:10,padding:'1.5rem',textAlign:'center',cursor:'pointer',background:T.s3}}>
          {portfolioUploaded?<div style={{color:T.teal,fontWeight:700}}>✓ Sample uploaded</div>:<div><div style={{fontSize:24,marginBottom:6}}>📁</div><div style={{color:T.text2,fontSize:12}}>Click to upload a work sample</div><div style={{color:T.text3,fontSize:10,marginTop:4}}>Any file type · Max 50MB</div></div>}
        </div>
        <input id="portfolio-upload" type="file" style={{display:'none'}} onChange={e=>{if(e.target.files[0]){setFile(e.target.files[0]);onPortfolioUpload(true);}}}/>
      </Field>
      {crafts.length===0&&<div style={{fontSize:10,color:T.rust,marginTop:4}}>Please select at least one craft.</div>}
      {!portfolioUploaded&&<div style={{fontSize:10,color:T.rust,marginTop:4}}>Please upload at least one work sample.</div>}
      {crafts.length>0&&portfolioUploaded&&<div style={{fontSize:11,color:T.teal,marginTop:8}}>✓ Identity requirements met. Your account will be active immediately.</div>}
    </div>
  );
}

export default function AccountTypeSelector({ onComplete }) {
  const [step, setStep] = useState(1); // 1=type, 2=subtype, 3=verification, 4=confirm
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSubtype, setSelectedSubtype] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [ein, setEIN] = useState('');
  const [einStatus, setEINStatus] = useState('unverified');
  const [crafts, setCrafts] = useState([]);
  const [portfolioUploaded, setPortfolioUploaded] = useState(false);

  const type = ACCOUNT_TYPES.find(t=>t.id===selectedType);

  const verifyEIN = async () => {
    if (!businessName.trim() || ein.length < 9) return;
    setEINStatus('pending');
    // Beta: simulate verification with 2s delay, always returns pending for manual review
    // Production: replace with Middesk or IRS TIN Matching API call
    await new Promise(r=>setTimeout(r,2000));
    // Format check: valid EIN format XX-XXXXXXX
    const einRegex = /^\d{2}-\d{7}$/;
    if (einRegex.test(ein) && businessName.length > 2) {
      setEINStatus('verified');
    } else {
      setEINStatus('failed');
    }
  };

  const canProceed = () => {
    if (step===1) return !!selectedType;
    if (step===2) return !!selectedSubtype;
    if (step===3) {
      if (type?.requiresEIN) return einStatus==='verified'||einStatus==='failed';
      if (type?.requiresPortfolio) return crafts.length>0&&portfolioUploaded;
      return true;
    }
    return true;
  };

  const handleComplete = () => {
    onComplete({
      account_type: selectedType,
      account_subtype: selectedSubtype,
      business_name: businessName||null,
      ein: ein||null,
      ein_verified: einStatus==='verified',
      ein_verification_status: einStatus,
      crafts_declared: crafts.length>0,
      portfolio_uploaded: portfolioUploaded,
      identity_gate_passed: type?.requiresPortfolio?(crafts.length>0&&portfolioUploaded):true,
    });
  };

  return (
    <div style={{minHeight:'100vh',background:T.bg,display:'flex',alignItems:'center',justifyContent:'center',padding:20,fontFamily:"'DM Sans','Jost',sans-serif"}}>
      <div style={{width:'100%',maxWidth:680}}>
        {/* Header */}
        <div style={{textAlign:'center',marginBottom:32}}>
          <div style={{fontSize:28,marginBottom:8}}>✦</div>
          <div style={{fontSize:22,fontWeight:700,color:T.gold,marginBottom:4}}>Welcome to Artizan</div>
          <div style={{fontSize:13,color:T.text2}}>Tell us who you are so we can build the right experience for you.</div>
          <div style={{display:'flex',justifyContent:'center',gap:8,marginTop:16}}>
            {[1,2,3,4].map(s=>(
              <div key={s} style={{width:s<=step?32:20,height:4,borderRadius:2,background:s<=step?T.gold:T.s3,transition:'all 0.3s'}}/>
            ))}
          </div>
        </div>

        {/* Step 1: Account Type */}
        {step===1 && (
          <div>
            <div style={{fontSize:11,color:T.gold,fontWeight:700,textTransform:'uppercase',letterSpacing:2,marginBottom:16}}>Step 1 — What best describes you?</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20}}>
              {ACCOUNT_TYPES.map(t=>(
                <div key={t.id} onClick={()=>setSelectedType(t.id)} style={{background:selectedType===t.id?'rgba(212,168,83,0.08)':T.s2,border:`1px solid ${selectedType===t.id?T.gold:T.border}`,borderRadius:12,padding:'14px 16px',cursor:'pointer',transition:'all 0.2s'}}>
                  <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:6}}>
                    <span style={{fontSize:18}}>{t.icon}</span>
                    <div style={{fontSize:13,fontWeight:700,color:selectedType===t.id?T.gold:T.cream}}>{t.label}</div>
                    {t.isEntity&&<span style={{fontSize:9,color:T.teal,background:'rgba(26,138,118,0.15)',border:`1px solid ${T.teal}30`,borderRadius:3,padding:'1px 5px',fontWeight:700}}>ENTITY</span>}
                  </div>
                  <div style={{fontSize:11,color:T.text2,lineHeight:1.6}}>{t.desc}</div>
                </div>
              ))}
            </div>
            <Btn gold disabled={!selectedType} onClick={()=>setStep(2)} style={{width:'100%'}}>Continue →</Btn>
          </div>
        )}

        {/* Step 2: Subtype */}
        {step===2 && type && (
          <div>
            <div style={{fontSize:11,color:T.gold,fontWeight:700,textTransform:'uppercase',letterSpacing:2,marginBottom:16}}>Step 2 — What kind of {type.label}?</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:20}}>
              {type.subtypes.map(s=>(
                <div key={s} onClick={()=>setSelectedSubtype(s)} style={{background:selectedSubtype===s?'rgba(212,168,83,0.08)':T.s2,border:`1px solid ${selectedSubtype===s?T.gold:T.border}`,borderRadius:10,padding:'10px 14px',cursor:'pointer',fontSize:12,color:selectedSubtype===s?T.gold:T.cream,fontWeight:selectedSubtype===s?700:400,transition:'all 0.2s'}}>
                  {s}
                </div>
              ))}
            </div>
            <div style={{background:T.s2,border:`1px solid ${T.border}`,borderRadius:10,padding:12,marginBottom:16}}>
              <div style={{fontSize:11,color:T.gold,fontWeight:700,marginBottom:8}}>What you get with {type.label}:</div>
              <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                {type.permissions.map(p=>(
                  <span key={p} style={{background:T.s3,border:`1px solid ${T.border2}`,borderRadius:20,padding:'3px 10px',fontSize:10,color:T.text2}}>✓ {p}</span>
                ))}
              </div>
            </div>
            <div style={{display:'flex',gap:10}}>
              <Btn onClick={()=>setStep(1)} style={{flex:1}}>← Back</Btn>
              <Btn gold disabled={!selectedSubtype} onClick={()=>setStep(3)} style={{flex:2}}>Continue →</Btn>
            </div>
          </div>
        )}

        {/* Step 3: Verification */}
        {step===3 && type && (
          <div>
            <div style={{fontSize:11,color:T.gold,fontWeight:700,textTransform:'uppercase',letterSpacing:2,marginBottom:16}}>Step 3 — Verification</div>
            {type.requiresEIN && (
              <EINVerification businessName={businessName} ein={ein} onBusinessNameChange={setBusinessName} onEINChange={setEIN} verificationStatus={einStatus} onVerify={verifyEIN}/>
            )}
            {type.requiresPortfolio && (
              <PortfolioGate crafts={crafts} onCraftsChange={setCrafts} portfolioUploaded={portfolioUploaded} onPortfolioUpload={setPortfolioUploaded}/>
            )}
            {!type.requiresEIN && !type.requiresPortfolio && (
              <div style={{background:T.s2,border:`1px solid ${T.border2}`,borderRadius:12,padding:20,textAlign:'center'}}>
                <div style={{fontSize:24,marginBottom:8}}>✓</div>
                <div style={{fontSize:13,color:T.cream,fontWeight:700,marginBottom:4}}>No additional verification required</div>
                <div style={{fontSize:11,color:T.text2}}>Your account will be active immediately. Build your profile and verification score to unlock more features.</div>
              </div>
            )}
            <div style={{display:'flex',gap:10,marginTop:16}}>
              <Btn onClick={()=>setStep(2)} style={{flex:1}}>← Back</Btn>
              <Btn gold disabled={!canProceed()} onClick={()=>setStep(4)} style={{flex:2}}>Continue →</Btn>
            </div>
          </div>
        )}

        {/* Step 4: Confirm */}
        {step===4 && type && (
          <div>
            <div style={{fontSize:11,color:T.gold,fontWeight:700,textTransform:'uppercase',letterSpacing:2,marginBottom:16}}>Step 4 — Confirm & Launch</div>
            <div style={{background:T.s2,border:`1px solid ${T.border2}`,borderRadius:12,padding:20,marginBottom:16}}>
              <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
                <span style={{fontSize:28}}>{type.icon}</span>
                <div>
                  <div style={{fontSize:16,fontWeight:700,color:T.gold}}>{type.label}</div>
                  <div style={{fontSize:12,color:T.text2}}>{selectedSubtype}</div>
                  {businessName&&<div style={{fontSize:11,color:T.text3,marginTop:2}}>{businessName}</div>}
                </div>
                {einStatus==='verified'&&<span style={{marginLeft:'auto',fontSize:10,color:T.teal,background:'rgba(26,138,118,0.15)',border:`1px solid ${T.teal}30`,borderRadius:4,padding:'3px 8px',fontWeight:700}}>✓ VERIFIED BUSINESS</span>}
              </div>
              <div style={{fontSize:11,color:T.text3,lineHeight:1.8,borderTop:`1px solid ${T.border}`,paddingTop:12}}>
                By clicking Launch, you agree to the Artizan Terms of Service and confirm that all information provided is accurate. Providing false business information is grounds for immediate account termination.
              </div>
            </div>
            <div style={{display:'flex',gap:10}}>
              <Btn onClick={()=>setStep(3)} style={{flex:1}}>← Back</Btn>
              <Btn gold onClick={handleComplete} style={{flex:2}}>Launch My Account ✦</Btn>
            </div>
          </div>
        )}
        <style>{'@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.3}}'}</style>
      </div>
    </div>
  );
}